export default "__VITE_ASSET__B2k1fpun__"